import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { IGoogleMerchantSettingsState, SLICE_NAME } from './models';

const merchantSettingsSelector = (state: RootState): IGoogleMerchantSettingsState => state[SLICE_NAME];

export const selectGoogleMerchantSettings = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSettingsState) => state.data,
);

export const selectGoogleMerchantSettingsIsLoading = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSettingsState) => state.isLoading,
);

export const selectGoogleMerchantSettingsError = createSelector(
  merchantSettingsSelector,
  (state: IGoogleMerchantSettingsState) => state.error,
);
